import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Reset scroll on every route change.
 * - Public pages: window / documentElement
 * - Staff panels: #adminMain (the actual scroll container)
 * Manual history.scrollRestoration avoids the browser fighting SPA navigation.
 */
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    // In-page anchors keep their target; everything else starts at the top.
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      if (!id) return;

      let tries = 0;
      const maxTries = 20;

      function scrollToHash() {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ block: 'start', behavior: 'smooth' });
          return;
        }
        tries += 1;
        if (tries < maxTries) {
          requestAnimationFrame(scrollToHash);
        }
      }

      requestAnimationFrame(scrollToHash);
      return;
    }

    requestAnimationFrame(() => {
      const adminMain = document.getElementById('adminMain');
      if (adminMain) {
        adminMain.scrollTop = 0;
        adminMain.scrollLeft = 0;
      }
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, [pathname, search, hash]);

  return null;
}
